import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Out-Of-Pocket Cost';
const pageSubTitle = 'Out-Of-Pocket Cost';
const videoKey = '2bkTqtKuZ8c';

const OutOfPocketCost = () => {

    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={
                <p>
                    Out-of-Pocket Cost reflects how important it is to minimize personal expenses when
                    selecting a treatment. This includes co-pays, deductibles, and any services not
                    covered by insurance.
                    <br/>
                    For example:
                    <br/>
                    <ul style={{ marginLeft: 16 }}>
                        <li>
                            NSAIDs and Cortisone Injections are typically lower-cost options.
                        </li>
                        <li>
                            PRP and Hyaluronic Acid Injections may cost more and are less likely to be
                            covered.
                        </li>
                        <li>
                            Total Knee Replacement can involve substantial out-of-pocket costs depending
                            on insurance coverage.
                        </li>
                    </ul>
                    <br/>
                    This criterion helps identify treatments that are financially sustainable and better
                    aligned with cost concerns.
                </p>
            }
            videoKey={videoKey}
            pageType="criteria"
        />
    );

};

export default OutOfPocketCost;